module.exports = __webpack_public_path__ + "img/0018.3420df21.gif";